import { Box, Paragraph, TextButton } from '@zillow/constellation-10';
import { useQuery } from '@zg-rentals/react-query5';
import {
  PortalAnalyticsWebApiHandler_getUserSalesProInfo,
  PortalAnalyticsWebApiHandler_getUserSalesProInfo_Path,
} from '@zg-rentals/ts-customer-analytics-client';
import { httpClient } from '../../httpClient';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import { emitOverviewMessageSalesProEvent } from '../../analytics/events';

const DEFAULT_EMAIL = 'rentalpartners@zillowgroup.com';

export const SalesProCard = ({
  title,
  description,
  buttonText,
}: {
  title: string;
  description: string;
  buttonText: string;
}) => {
  const { user } = useRentalManagerUser();
  const { data: salesProInfo } = useQuery({
    queryKey: [PortalAnalyticsWebApiHandler_getUserSalesProInfo_Path],
    queryFn: () => PortalAnalyticsWebApiHandler_getUserSalesProInfo(httpClient),
  });

  const salesPro = salesProInfo?.[0];
  const salesProEmail = salesPro?.userEmail || DEFAULT_EMAIL;
  const salesProName = salesPro?.userName || 'your sales pro';

  const displayButtonText = buttonText.replace('[sales pro name]', salesProName);

  return (
    <Box css={{ margin: '400', backgroundColor: 'Card.Root.soft.bg', borderRadius: '300', padding: '400' }}>
      <Paragraph textStyle="body-bold">{title}</Paragraph>
      <Paragraph css={{ marginBlockEnd: '200' }}>{description}</Paragraph>
      <TextButton asChild>
        <a
          href={`mailto:${salesProEmail}`}
          onClick={() => {
            if (user) emitOverviewMessageSalesProEvent({ user });
          }}
        >
          {displayButtonText}
        </a>
      </TextButton>
    </Box>
  );
};
